import { isConversionAuthorized } from './utils';
import {
  STORAGE_SERVICE,
  LOCAL_STORAGE_NAME,
  EXPIRATION_MILLISECONDS
} from './utils/constants';
import { getCurrenciesViewBean } from './services';

export class CurrencyService {
  constructor() {
    this.data = null;
    this.conversionAuthorized = isConversionAuthorized();
  }
  async getCurrencyContext() {
    const item = STORAGE_SERVICE.get(LOCAL_STORAGE_NAME);
    if (item) {
      item.conversionAuthorized = this.conversionAuthorized;
      this.data = item;
      return this.data;
    } else {
      try {
        const currenciesViewBean = await getCurrenciesViewBean();
        // save to storage
        const expiration = Date.now() + EXPIRATION_MILLISECONDS;
        STORAGE_SERVICE.set(
          LOCAL_STORAGE_NAME,
          { currenciesViewBean },
          expiration
        );
        // return data
        this.setCurrencyContext({
          conversionAuthorized: this.conversionAuthorized,
          currenciesViewBean
        });

        return this.data;
      } catch (error) {
        Promise.reject(error);
      }
    }
  }
  setCurrencyContext(data) {
    this.data = data;
  }
  static init() {
    return (async function () {
      const currencyService = new CurrencyService();
      await currencyService.getCurrencyContext();
      return currencyService;
    })();
  }

  getCurrencyName(currency) {
    if (!this.data) {
      throw new Error('Must init data with getCurrencyContext or init methods');
    }
    if (!currency) {
      throw new Error('getCurrencyName - currency param missing');
    }

    try {
      const {
        currenciesViewBean: { currenciesName }
      } = this.data;

      const currencyName = currenciesName[currency];
      if (!currencyName) {
        throw new Error('Unknown currency supplied');
      }
      return currencyName;
    } catch (error) {
      return (
        error.message || `getCurrencyName fn - an error occured  : ${error}`
      );
    }
  }

  getCurrenciesNames() {
    if (!this.data) {
      throw new Error('Must init data with getCurrencyContext or init methods');
    }
    try {
      const {
        currenciesViewBean: { currenciesName }
      } = this.data;
      return currenciesName;
    } catch (error) {
      return `getCurrenciesNames fn - an error occured : ${error}`;
    }
  }

  getCurrencyRate(currency) {
    if (!this.data) {
      throw new Error('Must init data with getCurrencyContext or init methods');
    }
    if (!currency) {
      throw new Error('getCurrencyRate - currency param missing');
    }

    try {
      const {
        currenciesViewBean: { currencies }
      } = this.data;
      const currencyRate = currencies[currency];
      if (!currencyRate) {
        throw new Error('Unknown currency supplied');
      }
      return currencyRate;
    } catch (error) {
      return (
        error.message || `getcurrencyRate fn - an error occured  : ${error}`
      );
    }
  }

  getCurrenciesRates() {
    if (!this.data) {
      throw new Error('Must init data with getCurrencyContext or init methods');
    }
    try {
      const {
        currenciesViewBean: { currencies }
      } = this.data;
      return currencies;
    } catch (error) {
      return `getCurrenciesRates fn - an error occured  : ${error}`;
    }
  }

  getCurrenciesByContinent(continent) {
    if (!this.data) {
      throw new Error('Must init data with getCurrencyContext or init methods');
    }
    if (!continent) {
      throw new Error('getCurrenciesByContinent - continent param missing');
    }

    try {
      const {
        currenciesViewBean: { displayCurrenciesMap }
      } = this.data;
      const currenciesByContinent = displayCurrenciesMap[continent];
      if (!currenciesByContinent) {
        throw new Error('Unknown continent supplied');
      }
      return currenciesByContinent;
    } catch (error) {
      return (
        error.message ||
        `getCurrenciesByContinent fn - an error occured  : ${error}`
      );
    }
  }

  getCurrenciesByContinents() {
    if (!this.data) {
      throw new Error('Must init data with getCurrencyContext or init methods');
    }
    try {
      const {
        currenciesViewBean: { displayCurrenciesMap }
      } = this.data;
      return displayCurrenciesMap;
    } catch (error) {
      return `getCurrenciesRates fn - an error occured : ${error}`;
    }
  }
}

export const dispatchConversionEvent = (currency = null) => {
  if (!currency) {
    throw new TypeError(
      'dispatchConversionEvent - currency param was not provided'
    );
  }
  const event = new CustomEvent('updateCurrencyPrice', {
    detail: { currency }
  });
  window.dispatchEvent(event, 3, true);
};
